/*

This file exports the DEFAULT slice layouts for the site, which allows Shapeable sites
to use a standard set of components based on our design library.

These can be overridden by passing a custom set of layouts to the SliceLayoutsProvider in the website.

*/
import { createSliceLayout } from "../entities/slice-layout";
import { PageKnowledgeHubLayout } from "../entities/page-knowledge-hub-layout";
import { SliceBackgroundImage } from "../entities/slice-background-image";
import { SliceBannerTout } from "../entities/slice-banner-tout";
import { SliceBlockBubbleLinks } from "../entities/slice-block-bubble-links";
import { SliceBlockBubbles } from "../entities/slice-block-bubbles";
import { SliceBlockGrid } from "../entities/slice-block-grid";
import { SliceBlockThumbnailGrid } from "../entities/slice-block-thumbnail-grid";
import { SliceBlurbImage } from "../entities/slice-blurb-image";
import { SliceBlurbVideo } from "../entities/slice-blurb-video";
import { SliceColorStrip } from "../entities/slice-color-strip";
import { SliceContactForm } from "../entities/slice-contact-form";
import { SliceContent } from "../entities/slice-content";
import { SliceContentBlockLinks } from "../entities/slice-content-block-links";
import { SliceContentEntityQuote } from "../entities/slice-content-entity-quote";
import { SliceContentImage } from "../entities/slice-content-image";
import { SliceCurrentEvents } from "../entities/slice-current-events";
import { SliceDivider } from "../entities/slice-divider";
import { SliceFeatureTout } from "../entities/slice-feature-tout";
import { SliceFeaturedOrganisation } from "../entities/slice-featured-organisation";
import { SliceFeaturedPosts } from "../entities/slice-featured-posts";
import { SliceHairline } from "../entities/slice-hairline";
import { SliceHeader } from "../entities/slice-header";
import { SliceHeaderDivider } from "../entities/slice-header-divider";
import { SliceImage } from "../entities/slice-image";
import { SliceImageBlocks } from "../entities/slice-image-blocks";
import { SliceIntro } from "../entities/slice-intro";
import { SliceJumpLinks } from "../entities/slice-jump-links";
import { SliceKeyMessage } from "../entities/slice-key-message";
import { SliceLatestInsights } from "../entities/slice-latest-insights";
import { SliceOrganisationBioGrid } from "../entities/slice-organisation-bio-grid";
import { SliceOrganisations } from "../entities/slice-organisations";
import { SlicePastEvents } from "../entities/slice-past-events";
import { SlicePersonBioGrid } from "../entities/slice-person-bio-grid";
import { SliceQuestion } from "../entities/slice-question";
import { SliceSectionColorBlock } from "../entities/slice-section-color-block";
import { SliceSpacer } from "../entities/slice-spacer";
import { SliceThumbnailStrip } from "../entities/slice-thumbnail-strip";
import { SliceUpcomingEvents } from "../entities/slice-upcoming-events";
import { SliceValueTout } from "../entities/slice-value-tout";
import { SliceIndicatorGroupsSidebar } from "../entities/slice-indicator-groups-sidebar";
import { SliceIndicatorsSidebar } from "../entities/slice-indicators-sidebar";
import { SliceIndicatorsPanel } from "../entities/slice-indicators-panel";
import { SliceIndicatorGroupsPanel } from "../entities/slice-indicator-groups-panel";
import { SliceContentPanel } from "../entities/slice-content-panel";
import { SliceMediaArticlesPanel } from "../entities/slice-media-articles-panel";
import { SliceMarketMapPanel } from "../entities/slice-market-map-panel";
import { SliceViewIntro } from "../entities/slice-view-intro";
import { SliceMarketMapGrid } from "../entities/slice-market-map-grid";
import { SliceStakeholdersGrid } from "../entities/slice-stakeholders-grid";
import { SliceConnections } from "../entities/slice-connections";
import { SliceConnectionsPanel } from "../entities/slice-connections-panel";
import { SliceConnectionsSidebar } from "../entities/slice-connections-sidebar";
import { SliceContactInfo } from "../entities/slice-contact-info";
import { SliceDescription } from "../entities/slice-description";
import { SlicePersonBanner } from "../entities/slice-person-banner";
import { SliceColleaguesList } from "../entities/slice-colleagues-list";
import { SliceOrganisationBanner } from "../entities/slice-organisation-banner";
import { SlicePartnerOrganisationsGrid } from "../entities/slice-partner-organisations-grid";
import { SliceEntityViewAsideMobile } from "../entities/slice-entity-view-aside-mobile";
import { SliceThemeInsights } from "../entities/slice-theme-insights";
import { SliceConversation } from "../entities/slice-conversations";
import { SliceModerators } from "../entities/slice-moderators";
import { SliceOnboardingProfileTypesGrid } from "../entities/slice-onboarding-profile-types-grid";
import { SliceOnboardingObjectivesGrid } from "../entities/slice-onboarding-objectives-grid";
import { SliceOnboardingTrendExpertiseGrid } from "../entities/slice-onboarding-trend-expertise-grid";
import { SliceWorkstreams } from "../entities/slice-workstreams";
export var SliceLayoutBannerTout = createSliceLayout(SliceBannerTout, {
  verticalPadding: 'large'
});
export var SliceLayoutBlurbImage = createSliceLayout(SliceBlurbImage, {
  verticalPadding: 'small'
});
export var SliceLayoutBlurbVideo = createSliceLayout(SliceBlurbVideo, {
  verticalPadding: 'small'
});
export var SliceLayoutBackgroundImage = createSliceLayout(SliceBackgroundImage);
export var SliceLayoutBlockBubbleLinks = createSliceLayout(SliceBlockBubbleLinks);
export var SliceLayoutBlockBubbles = createSliceLayout(SliceBlockBubbles);
export var SliceLayoutBlockGrid = createSliceLayout(SliceBlockGrid, {
  verticalPadding: 'content'
});
export var SliceLayoutBlockThumbnailGrid = createSliceLayout(SliceBlockThumbnailGrid, {
  verticalPadding: 'none',
  themeMode: 'dark',
  boundary: 'none',
  props: {
    columns: 0,
    landscapeAutoColumns: 1,
    tabletMinColumns: 3,
    tabletAutoColumns: 3,
    desktopMinColumns: 3,
    desktopLargeAutoColumns: 3,
    desktopFullHdAutoColumns: 3
  }
});
export var SliceLayoutBlockThumbnailCardGrid = createSliceLayout(SliceBlockThumbnailGrid, {
  verticalPadding: 'none',
  boundary: 'none',
  props: {
    variant: 'card',
    columns: 0,
    spacing: 0.5,
    tabletMinColumns: 2,
    desktopMinColumns: 4,
    desktopLargeAutoColumns: 4,
    desktopFullHdAutoColumns: 4
  }
});
export var SliceLayoutColorStrip = createSliceLayout(SliceColorStrip, {
  props: {
    colors: ['primary', 'secondary']
  }
});
export var SliceLayoutContactForm = createSliceLayout(SliceContactForm, {
  props: {
    variant: 'inline',
    showMembershipCheckbox: false
  }
});
export var SliceLayoutContactInfo = createSliceLayout(SliceContactInfo, {
  verticalPadding: 'small',
  boundary: 'none'
});
export var SliceLayoutContentBlockLinks = createSliceLayout(SliceContentBlockLinks, {
  verticalPadding: 'medium'
});
export var SliceLayoutContent = createSliceLayout(SliceContent, {
  verticalPadding: 'small'
});
export var SliceLayoutContentEntityQuote = createSliceLayout(SliceContentEntityQuote, {
  boundary: 'none',
  props: {
    parallax: true
  }
});
export var SliceLayoutContentImage = createSliceLayout(SliceContentImage, {
  verticalPadding: 'small'
});
export var SliceLayoutContentImageReverse = createSliceLayout(SliceContentImage, {
  verticalPadding: 'small',
  props: {
    reverse: true
  }
});
export var SliceLayoutConversation = createSliceLayout(SliceConversation, {
  boundary: 'none',
  verticalPadding: 'content'
});
export var SliceLayoutDivider = createSliceLayout(SliceDivider, {
  boundary: 'content-bleed'
});
export var SliceLayoutHairline = createSliceLayout(SliceHairline, {
  boundary: 'content-bleed'
});
export var SliceLayoutFeaturedPosts = createSliceLayout(SliceFeaturedPosts, {
  boundary: 'content',
  props: {}
});
export var SliceLayoutFeatureTout = createSliceLayout(SliceFeatureTout);
export var SliceLayoutFeaturedOrganisation = createSliceLayout(SliceFeaturedOrganisation, {
  verticalPadding: 'large'
});
export var SliceLayoutHeader = createSliceLayout(SliceHeader, {
  verticalPadding: 'small'
});
export var SliceLayoutHeaderDivider = createSliceLayout(SliceHeaderDivider, {
  verticalPadding: 'content'
});
export var SliceLayoutImage = createSliceLayout(SliceImage, {
  boundary: 'content',
  useBackgroundImages: false // turn off background images, as we want to push this one to the foreground to allow optimisation
});
export var SliceLayoutImageFill = createSliceLayout(SliceImage, {
  boundary: 'none',
  useBackgroundImages: false // turn off background images, as we want to push this one to the foreground to allow optimisation
});
export var SliceLayoutMarketMapGrid = createSliceLayout(SliceMarketMapGrid, {
  boundary: 'none',
  verticalPadding: 'small'
});
export var SliceLayoutModerators = createSliceLayout(SliceModerators, {
  boundary: 'none',
  verticalPadding: 'none'
});
export var SliceLayoutContentPanel = createSliceLayout(SliceContentPanel, {
  boundary: 'none',
  verticalPadding: 'panel',
  verticalBalanceDelta: 0
});
export var SliceLayoutIndicatorsPanel = createSliceLayout(SliceIndicatorsPanel, {
  boundary: 'none',
  verticalPadding: 'panel',
  verticalBalanceDelta: 0
});
export var SliceLayoutIndicatorGroupsPanel = createSliceLayout(SliceIndicatorGroupsPanel, {
  boundary: 'none',
  verticalPadding: 'panel',
  verticalBalanceDelta: 0
});
export var SliceLayoutMediaArticlesPanel = createSliceLayout(SliceMediaArticlesPanel, {
  boundary: 'none',
  verticalPadding: 'panel',
  verticalBalanceDelta: 0
});
export var SliceLayoutMarketMapPanel = createSliceLayout(SliceMarketMapPanel, {
  boundary: 'none',
  verticalPadding: 'panel',
  verticalBalanceDelta: 0
});
export var SliceLayoutIndicatorGroupsSidebar = createSliceLayout(SliceIndicatorGroupsSidebar, {
  boundary: 'none',
  verticalPadding: 'none'
});
export var SliceLayoutIndicatorsSidebar = createSliceLayout(SliceIndicatorsSidebar, {
  boundary: 'none',
  verticalPadding: 'none'
});
export var SliceLayoutViewIntro = createSliceLayout(SliceViewIntro, {
  boundary: 'none',
  verticalPadding: 'small'
});
export var SliceLayoutIntro = createSliceLayout(SliceIntro, {
  verticalPadding: 'large'
});
export var SliceLayoutJumpLinks = createSliceLayout(SliceJumpLinks, {
  boundary: 'content'
});
export var SliceLayoutKeyMessage = createSliceLayout(SliceKeyMessage, {
  verticalPadding: 'large'
});
export var SliceLayoutKnowledgeHub = createSliceLayout(PageKnowledgeHubLayout, {
  boundary: 'content-bleed',
  verticalPadding: 'medium',
  props: {
    showAllTab: true,
    entityTypes: {
      Post: {
        label: 'Posts',
        sortBy: 'published',
        reverse: true
      },
      FeedEntry: {
        label: 'Articles',
        sortBy: 'published',
        reverse: true
      },
      Citation: {
        label: 'Research',
        spacing: 4
      },
      Video: {
        label: 'Video'
      }
    }
  }
});
export var SliceLayoutLatestInsights = createSliceLayout(SliceLatestInsights, {
  boundary: 'content-bleed',
  verticalPadding: 'small'
});
export var SliceLayoutThemeInsights = createSliceLayout(SliceThemeInsights, {
  boundary: 'content-bleed',
  verticalPadding: 'small'
});
export var SliceLayoutOrganisationBioGrid = createSliceLayout(SliceOrganisationBioGrid, {
  verticalPadding: 'content'
});
export var SliceLayoutOrganisations = createSliceLayout(SliceOrganisations, {
  verticalPadding: 'content'
});
export var SliceLayoutCurrentEvents = createSliceLayout(SliceCurrentEvents, {
  boundary: 'content',
  verticalPadding: 'content'
});
export var SliceLayoutPartneredOrganisationsGrid = createSliceLayout(SlicePartnerOrganisationsGrid, {
  verticalPadding: 'panel',
  boundary: 'none'
});
export var SliceLayoutPastEvents = createSliceLayout(SlicePastEvents, {
  verticalPadding: 'content'
});
export var SliceLayoutPeople = createSliceLayout(SlicePersonBioGrid, {
  verticalPadding: 'small',
  props: {
    transform: 'grayscale'
  }
});
export var SliceLayoutQuestion = createSliceLayout(SliceQuestion, {
  boundary: 'content'
});
export var SliceLayoutSection = createSliceLayout(SliceSectionColorBlock, {
  themeMode: 'dark',
  boundary: 'none',
  props: {
    aspectRatio: {
      base: 16 / 9,
      landscape: 21 / 9,
      tablet: 21 / 9,
      desktop: 2.5
    }
  }
});
export var SliceLayoutSectionReverse = createSliceLayout(SliceSectionColorBlock, {
  themeMode: 'dark',
  boundary: 'none',
  props: {
    aspectRatio: {
      base: 16 / 9,
      landscape: 21 / 9,
      tablet: 21 / 9,
      desktop: 2.5
    },
    isReversed: true
  }
});
export var SliceLayoutWorkstreams = createSliceLayout(SliceWorkstreams, {
  verticalPadding: 'small',
  boundary: 'none'
});
export var SliceLayoutKeyPillars = createSliceLayout(SliceImageBlocks, {
  verticalPadding: 'small'
});
export var SliceLayoutSpacer32 = createSliceLayout(SliceSpacer, {
  props: {
    units: 32 / 4
  }
});
export var SliceLayoutSpacer64 = createSliceLayout(SliceSpacer, {
  props: {
    units: 64 / 4
  }
});
export var SliceLayoutSpacer96 = createSliceLayout(SliceSpacer, {
  props: {
    units: 96 / 4
  }
});
export var SliceLayoutSpacer128 = createSliceLayout(SliceSpacer, {
  props: {
    units: 128 / 4
  }
});
export var SliceLayoutSpacer192 = createSliceLayout(SliceSpacer, {
  props: {
    units: 192 / 4
  }
});
export var SliceLayoutSpacer256 = createSliceLayout(SliceSpacer, {
  props: {
    units: 256 / 4
  }
});
export var SliceLayoutStakeholderGrid = createSliceLayout(SliceStakeholdersGrid, {
  boundary: 'none',
  verticalPadding: 'small'
});
export var SliceLayoutThumbnailStrip = createSliceLayout(SliceThumbnailStrip, {
  boundary: 'none'
});
export var SliceLayoutUpcomingEvents = createSliceLayout(SliceUpcomingEvents, {
  verticalPadding: 'content'
});
export var SliceLayoutValueTout = createSliceLayout(SliceValueTout, {
  boundary: 'content-bleed'
});
export var SliceLayoutOrganisationBanner = createSliceLayout(SliceOrganisationBanner, {
  boundary: 'none',
  verticalPadding: 'none'
});
export var SliceLayoutPersonBanner = createSliceLayout(SlicePersonBanner, {
  boundary: 'none',
  verticalPadding: 'none'
});
export var SliceLayoutDescription = createSliceLayout(SliceDescription, {
  boundary: 'none',
  verticalPadding: 'panel',
  verticalBalanceDelta: 0
});
export var SliceLayoutColleaguesList = createSliceLayout(SliceColleaguesList, {
  boundary: 'none',
  verticalPadding: 'panel',
  useEntityColors: true,
  verticalBalanceDelta: 0
});
export var SliceLayoutDefault = SliceLayoutContent;
var sliceLayoutEntityListOptions = {
  boundary: 'none',
  verticalPadding: 'panel',
  defaultBackgroundColor: {
    value: 'transparent'
  },
  useEntityColors: false,
  verticalBalanceDelta: 0
};
export var SliceLayoutConnections = createSliceLayout(SliceConnections, sliceLayoutEntityListOptions);
export var SliceLayoutConnectionsPanel = createSliceLayout(SliceConnectionsPanel, sliceLayoutEntityListOptions);
export var SliceLayoutEntityViewAsideMobile = createSliceLayout(SliceEntityViewAsideMobile, {
  boundary: 'none',
  verticalPadding: 'panel'
});
export var SliceLayoutConnectionsSidebar = createSliceLayout(SliceConnectionsSidebar, {
  boundary: 'none',
  verticalPadding: 'none',
  defaultBackgroundColor: {
    value: 'transparent'
  },
  useEntityColors: false
});
// testing below slices
export var SliceLayoutOnboardingProfileTypesGrid = createSliceLayout(SliceOnboardingProfileTypesGrid, {
  verticalPadding: 'none',
  boundary: 'none',
  defaultBackgroundColor: {
    value: 'transparent'
  }
});
export var SliceLayoutOnboardingObjectivesGrid = createSliceLayout(SliceOnboardingObjectivesGrid, {
  verticalPadding: 'none',
  boundary: 'none',
  defaultBackgroundColor: {
    value: 'transparent'
  }
});
export var SliceLayoutOnboardingTrendExpertiseGrid = createSliceLayout(SliceOnboardingTrendExpertiseGrid, {
  verticalPadding: 'none',
  boundary: 'none',
  defaultBackgroundColor: {
    value: 'transparent'
  }
});